import React from 'react';
import "./HeadingSectionLayout.css";

const HeadingSectionLayout = (props) => {
  return (
    <div className="section-heading">
      <span className="line left"></span>

      <h3 className="title text-uppercase">
         {props.title}
      </h3>

      <span className="line right"></span>
    </div>
  )
}

export default HeadingSectionLayout